import styled from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'

const Container = styled(Row)`
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  margin-bottom: ${(props) => props.theme.size.spacing.lg};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  flex-basis: auto;
  color: ${(props) => props.theme.color.monochrome.darker};
  overflow: hidden;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    min-height: 400px;
  }
`

const ImageWrapper = styled(Row)`
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  img {
    position: relative;
    height: 200px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
    margin-bottom: ${(props) => props.theme.size.spacing.lg};
    width: 100%;
    object-fit: cover;
    @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
      height: 100%;
    }
  }
`

const TextWrapper = styled(Column)`
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    background-color: ${(props) => props.theme.color.monochrome.white};
    opacity: 0.85;
    padding: 20px 15px;
    margin: 0 10px;
    z-index: 2;
    display: block;
    margin: ${(props) => props.theme.size.spacing.md};
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    padding: 25px 20px;
    margin: 0 ${(props) => props.theme.size.spacing.md};
  }
`

export { Container, ImageWrapper, TextWrapper }
